module.exports = __webpack_public_path__ + "static/travellogger-cf63d785b373e92edfe47ca2f27196e1.jpg";